import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Mail, Phone } from "lucide-react";
import { BRAND } from "@/lib/api";
import CartoonSticker from "./CartoonStickers";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="relative overflow-hidden gradient-navy text-white"
        >
            <CartoonSticker name="truck" width={120} rotate={-8} className="hidden lg:inline-flex right-12 top-12 truck-roll" />
            <CartoonSticker name="check" width={56} rotate={10} className="hidden xl:inline-flex right-1/4 bottom-16 float-y-slow" />

            <div className="container-atm relative py-20">
                <div className="grid gap-12 md:grid-cols-12">
                    <div className="md:col-span-5">
                        <Link
                            to="/"
                            className="group inline-flex items-center"
                            data-testid="footer-logo-link"
                        >
                            <span className="inline-flex items-center gap-3 rounded-2xl bg-white px-5 py-4 shadow-[0_14px_36px_-14px_rgba(0,0,0,0.45)] transition-transform duration-500 group-hover:scale-[1.02]">
                                <img
                                    src={BRAND.logo}
                                    alt="AllTask Moves"
                                    className="h-12 w-auto select-none sm:h-14"
                                    draggable={false}
                                />
                                <span className="flex flex-col leading-none">
                                    <span className="font-display text-2xl font-extrabold tracking-tight text-[#0E2A47] sm:text-3xl">
                                        ALLTASK
                                    </span>
                                    <span className="mt-1.5 flex items-center gap-2 font-display text-[10px] font-bold tracking-[0.45em] text-[#F26B1F] sm:text-xs">
                                        <span className="h-px w-3 bg-[#F26B1F]" /> MOVES <span className="h-px w-3 bg-[#F26B1F]" />
                                    </span>
                                </span>
                            </span>
                        </Link>
                        <p className="mt-6 max-w-md text-base leading-relaxed text-white/70">
                            Practical relocation and move-coordination support for
                            international clients, out-of-town movers, and local Toronto/GTA
                            residents.
                        </p>
                        <div className="mt-6 flex flex-col gap-2 text-sm text-white/70">
                            <span className="flex items-center gap-2">
                                <MapPin size={14} className="text-[#F26B1F]" />
                                Toronto / GTA, Canada
                            </span>
                            <a href="mailto:info@alltasksolutions.ca" data-testid="footer-email-link" className="flex items-center gap-2 transition-colors hover:text-[#F26B1F]">
                                <Mail size={14} className="text-[#F26B1F]" />
                                info@alltasksolutions.ca
                            </a>
                            <a href="tel:+16473602472" data-testid="footer-phone-link" className="flex items-center gap-2 transition-colors hover:text-[#F26B1F]">
                                <Phone size={14} className="text-[#F26B1F]" />
                                +1 647 360 2472
                            </a>
                        </div>
                        <Link
                            to="/book"
                            data-testid="footer-book-btn"
                            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#F26B1F] px-6 py-3 text-sm font-semibold text-white shadow-[0_10px_30px_rgba(242,107,31,0.35)] transition-all hover:-translate-y-0.5 hover:bg-[#D95A15]"
                        >
                            Book Free Consultation <ArrowUpRight size={16} />
                        </Link>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="text-sm font-semibold uppercase tracking-widest text-[#F26B1F]">
                            Services
                        </h4>
                        <ul className="mt-5 space-y-3 text-sm text-white/75">
                            <li><Link to="/services" className="hover:text-white">Consultations</Link></li>
                            <li><Link to="/services" className="hover:text-white">Shortlisting</Link></li>
                            <li><Link to="/services" className="hover:text-white">Move-Day</Link></li>
                            <li><Link to="/services" className="hover:text-white">Packing & Cleaning</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="text-sm font-semibold uppercase tracking-widest text-[#F26B1F]">
                            Company
                        </h4>
                        <ul className="mt-5 space-y-3 text-sm text-white/75">
                            <li><Link to="/services" className="hover:text-white">Services</Link></li>
                            <li><Link to="/services#pricing" className="hover:text-white">Pricing</Link></li>
                            <li><Link to="/task-partners" className="hover:text-white">Task Partners</Link></li>
                            <li><Link to="/faq" className="hover:text-white" data-testid="footer-faq-link">FAQ</Link></li>
                            <li><Link to="/book" className="hover:text-white">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="text-sm font-semibold uppercase tracking-widest text-[#F26B1F]">
                            Service boundaries
                        </h4>
                        <p className="mt-5 text-sm leading-relaxed text-white/65">
                            AllTask Moves provides relocation and move coordination support.
                            We do not provide legal, immigration, real estate brokerage,
                            financial, property inspection, guaranteed housing, or
                            international freight services.
                        </p>
                    </div>
                </div>

                <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-sm text-white/55 md:flex-row md:items-center">
                    <p>
                        © {new Date().getFullYear()} AllTask Moves. Toronto / GTA. Clear
                        pricing. Practical support. Trusted coordination.
                    </p>
                    <div className="flex items-center gap-5">
                        <Link
                            to="/admin/login"
                            className="hover:text-white"
                            data-testid="footer-admin-link"
                        >
                            Admin
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
